import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SobreMi from "../pages/sobre-mi/page";
import Servicios from "../pages/servicios/page";
import ComoLoHago from "../pages/como-lo-hago/page";
import CasosExito from "../pages/casos-de-exito/page";
import Blog from "../pages/blog/page";
import BlogArticle from "../pages/blog/article/page";
import Contacto from "../pages/contacto/page";
import Agenda from "../pages/agenda/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sobre-mi",
    element: <SobreMi />,
  },
  {
    path: "/servicios",
    element: <Servicios />,
  },
  {
    path: "/como-lo-hago",
    element: <ComoLoHago />,
  },
  {
    path: "/casos-de-exito",
    element: <CasosExito />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticle />,
  },
  {
    path: "/contacto",
    element: <Contacto />,
  },
  {
    path: "/agenda",
    element: <Agenda />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;